module.exports = __webpack_public_path__ + "img/a06e625.jpg";